// extracted by mini-css-extract-plugin
export default {"row":"PickupRequestTransactionLink_row__A+BLP","text":"PickupRequestTransactionLink_text__DnfHO","link":"PickupRequestTransactionLink_link__TInV2"};